import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_LINEITEMS_RECORDS, UPDATE_LINEITEM_RECORD, DELETE_LINEITEM_RECORD } from "../actions";

import {
  getLineItemsSuccess,
  getLineItemsError,
  updateLineItemSuccess,
  updateLineItemError,
  trashLineItemSuccess,
  trashLineItemError
} from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

export function* watchGetRecords() {
  yield takeEvery(GET_LINEITEMS_RECORDS, getRecordList);
}

export function* watchUpdateLineItemRecords() {
  yield takeEvery(UPDATE_LINEITEM_RECORD, updateLineItemRecord);
}

export function* watchDeleteLineItemRecords() {
  yield takeEvery(DELETE_LINEITEM_RECORD, deleteLineItemRecord);
}

const getCurrentPageRecords = (allRecords, pageNumber, pageSize) => {
  let currentPageRecords = [];
  if (Object.keys(allRecords).length > 0) {
    for (var key in allRecords) {
      currentPageRecords.push({
        ...allRecords[key],
        id: key,
      });
    }
  }
  let startIndex = (pageNumber - 1) * pageSize;
  let lastIndex = startIndex + pageSize;
  currentPageRecords = currentPageRecords.slice(
    startIndex,
    currentPageRecords.length >= lastIndex
      ? lastIndex
      : currentPageRecords.length
  );
  return currentPageRecords;
};



const deleteLineItemRecordAsync = async (payload) => {
  try {
    let responseObject = await centralApiAxios.delete("line_items?id=" + payload.lineItem.lineItemId, getActivityHeadersUpdated(payload));

    return {
      deletedLineItem: { ...payload.lineItem, trashed: true },
      message: null
    };
  } catch (error) {
    return {
      message: 'Failed to delete line item. ' + error
    }
  }
}

const updateLineItemAsync = async (payload) => {
  try {
    let responseObject = await centralApiAxios.put("line_items?id=" + payload.lineItem.lineItemId, payload.lineItem, getActivityHeadersUpdated(payload));
    return {
      lineItem: responseObject.data,
      message: null,
    };
  } catch (error) {
    return {
      message: 'Failed to update line item. ' + error
    }
  }
}

const getRecordListAsync = async (payload) => {

  try {
    let responseObject = {};
    if (payload.orderId > 0) {
      responseObject = await centralApiAxios.get("line_items?order_id=" + payload.orderId + "&trashed=false" + (payload.processCode ? ("&processCode=" + payload.processCode) : ""), getActivityHeadersUpdated(payload));
    }
    else {
      responseObject.data = {};
      responseObject.data.items = {};
    }

    return {
      recordList: responseObject.data.items,
      message: null,
    };
  } catch (error) {
    return {
      message: 'Failed to get line items. ' + error
    }
  }
}

function* getRecordList({ payload }) {
  try {
    const recordListReturned = yield call(getRecordListAsync, payload);
    if (!recordListReturned.message) {
      let recordListParam = {
        records: getCurrentPageRecords(
          recordListReturned.recordList,
          payload.pageNumber,
          5
        ),
        searchText: recordListReturned.searchText,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize: 5,
          startIndex: (payload.pageNumber - 1) * 5 + 1,
          totalItemCount: Object.keys(recordListReturned.recordList).length,
          totalPages: Math.ceil(
            Object.keys(recordListReturned.recordList).length / 5
          ),
        },
        responseTime: recordListReturned.responseTime,
      };
      yield put(getLineItemsSuccess(recordListParam));
    } else {
      yield put(getLineItemsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getLineItemsError(error));
  }
}

function* updateLineItemRecord({ payload }) {
  try {
    const recordListReturned = yield call(updateLineItemAsync, payload);
    if (!recordListReturned.message) {
      yield put(updateLineItemSuccess(recordListReturned));
    } else {
      yield put(updateLineItemError(recordListReturned.message));
    }
  } catch (error) {
    yield put(updateLineItemError(error));
  }
}

function* deleteLineItemRecord({ payload }) {
  try {
    const recordListReturned = yield call(deleteLineItemRecordAsync, payload);
    if (!recordListReturned.message) {
      yield put(trashLineItemSuccess(recordListReturned.deletedLineItem));
    } else {
      yield put(trashLineItemError(recordListReturned.message));
    }
  } catch (error) {
    yield put(trashLineItemError(error));
  }
}


export default function* rootSaga() {
  yield all([fork(watchGetRecords)]);
  yield all([fork(watchUpdateLineItemRecords)]);
  yield all([fork(watchDeleteLineItemRecords)]);
}

